export const SPACE_SETUP_REQUEST = "SPACE_SETUP_REQUEST";
export const SPACE_SETUP_RECEIVE = "SPACE_SETUP_RECEIVE";
export const SPACE_SETUP_FAILURE = "SPACE_SETUP_FAILURE";
export const RESET_SPACE_SETUP = "RESET_SPACE_SETUP";
